import { Injectable, Injector } from '@angular/core'
import { APIService } from 'api/module'
import { MediaFile, MediaFileBundle } from 'elements-sdk'
import { BaseClipboardService } from 'common/util/module'
import { isBundle } from 'media/helpers'

export interface ClipboardBaseItem {
  files: MediaFile[]
  state: 'cut' | 'copy'
}

export interface ClipboardBundleItem extends ClipboardBaseItem {
  bundle: MediaFileBundle
}

export interface ClipboardFileItem extends ClipboardBaseItem {
  file: MediaFile
}

export type ClipboardItem = ClipboardFileItem | ClipboardBundleItem

@Injectable({ providedIn: 'root' })
export class MediaClipboardService extends BaseClipboardService<ClipboardItem> {
  constructor (
    private api: APIService,
    injector: Injector,
  ) {
    super(injector, 'ml:clipboard')
  }

  copyFiles (
    items: MediaFile[],
    mode: 'cut' | 'copy',
  ): void {
    const files = items.filter(x => !isBundle(x))
    const filesId = files.map(x => x.id)

    this.items = this.items.filter(existing => {
      return 'bundle' in existing ||
        (!files.includes(existing.file) &&
        !filesId.includes(existing.file.id))
    })

    this.setItems([
      ...this.items,
      ...files.map(item => {
        return {
          file: item,
          files: [item],
          state: mode,
        }
      }),
    ])
  }

  async copyBundles (
    items: MediaFileBundle[],
    mode: 'cut' | 'copy',
  ): Promise<void> {
    const bundles = items.filter(x => isBundle(x))
    const bundlesId = bundles.map(x => x.id)

    this.items = this.items.filter(existing => {
      return 'file' in existing ||
        (!bundles.includes(existing.bundle) &&
        !bundlesId.includes(existing.bundle.id))
    })

    const files = await this.api.mediaLibrary.getAllMediaFilesForBundles({
      allMediaFilesForBundlesRequest: {
        bundles: bundles.map(item => item.id),
      },
    })

    this.setItems([
      ...this.items,
      ...bundles.map(item => {
        return {
          bundle: item,
          files: files.filter(file => file.bundle === item.id),
          state: mode,
        }
      }),
    ])
  }
}
